var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.planListData.length === 0),expression:"planListData.length === 0"}]},[_c('p',{staticClass:"mt-5 text-center font-weight-bold"},[_vm._v("尚未追蹤行程")])]),_c('MyPlanList',{attrs:{"plan-type":_vm.planType,"plan-list-data":_vm.newListData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }